<form [formGroup]="searchForm">
  <div>
    <mat-form-field>
      <mat-label>{{ title || "input-block-name" | translate }}</mat-label
      ><input
        type="text"
        matInput
        formControlName="name"
        [matAutocomplete]="auto"
      />
      <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
        <mat-option disabled class="loading" *ngIf="loading">
          <mat-spinner diameter="25"></mat-spinner>
        </mat-option>
        <mat-option
          *ngFor="let block of blocks$ | async"
          (onSelectionChange)="handleBlockChange($event, block)"
          [value]="block.tag"
          class="autocomplete"
        >
          {{ block.tag }}
        </mat-option>
      </mat-autocomplete>
      <mat-error
        translate
        *ngIf="this.searchForm.controls.name.touched && !this.searchForm.valid"
        >{{ requiredText || "required-block" | translate }}</mat-error
      >
    </mat-form-field>
  </div>
</form>
